import { Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfirmNewPhoneNumberRequest, CustomerContactData, CustomerContactDataDetails } from "../domain/models/customer.model";
import { ConfigService } from "../../../../lib/config/config.service";

@Injectable({ providedIn: "root" })
export class CustomerRemote {
  constructor(
    private http: HttpClient,
    private readonly configService: ConfigService,
  ) {}

  getPersonalInformation(
    customerId: number
  ): Observable<CustomerContactDataDetails> {
    const url = `${this.configService.environment.customers.url}/api/customer/${customerId}/personal-information`;
    return this.http.get<CustomerContactDataDetails>(url);
  }

  updatePersonalInformation(
    customerId: number,
    contactData: CustomerContactData
  ): Observable<any> {
    const url = `${this.configService.environment.customers.url}/api/customer/${customerId}/personal-information`;
    return this.http.patch(url, contactData);
  }

  confirmMobilePhoneNumberChange(
    request: ConfirmNewPhoneNumberRequest
  ): Observable<any> {
    let headers = {};
    if (request?.mfaToken) {
      headers = { ...headers, "X-Ryno-Mfa-Token": request?.mfaToken };
    }
    if (request?.mfaCode) {
      headers = { ...headers, "X-Ryno-Mfa-Code": request.mfaCode };
    }
    const url = `${this.configService.environment.customers.url}/api/customer/${request.customerId}/confirm-new-phone-number`;
    return this.http.patch(url, null, { headers });
  }

  discardMobilePhoneNumberChange(customerId: number): Observable<any> {
    const url = `${this.configService.environment.customers.url}/api/customer/${customerId}/discard-new-phone-number`;
    return this.http.patch(url, {});
  }

  getPendingMsaApplication(customerId: number): Observable<number> {
    const url = `${this.configService.environment.customers.url}/api/customer/${customerId}/application/msa-pending`;
    return this.http.get<number>(url);
  }
}
